import * as React from 'react';
import { withRouter } from 'react-router';

class ScrollToTop extends React.Component<any, any>{
    public state: any = {
        hasError: false,
        error: null,
        errorInfo: null
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }


    componentDidCatch(error: any, info: any) {
        // Display fallback UI
        this.setState({
            hasError: true,
            error: error,
            errorInfo: info
        });
    }

    render() {
        // if (!this.state.hasError)
            return this.props.children;
        // else
        //     return (
        //         <div>
        //             <h2>Something went wrong.</h2>
        //             <details style={{ whiteSpace: 'pre-wrap' }}>
        //                 {this.state.error && this.state.error.toString()}
        //                 <br />
        //                 {this.state.errorInfo.componentStack}
        //             </details>
        //         </div>
        //     );
    }
}

export default withRouter(ScrollToTop);